import React from "react";
import { Header } from "components/Header";
import SidebarComponent from "components/Sidebar";
import { DriverBottomNav } from "./DriverBottomNav";
import DriverNavConfig from "./navConfig";
import { Container, SidebarContainer, Content } from "./styles";

interface DriverLayoutProps {
  children: React.ReactNode;
}

export const DriverLayout = ({ children }: DriverLayoutProps) => {
  return (
    <Container>
      <Header homePath="/motorista" showSidebarToggle={false} />
      <SidebarContainer>
        <SidebarComponent items={DriverNavConfig} />
      </SidebarContainer>
      <Content>{children}</Content>
      <DriverBottomNav />
    </Container>
  );
};

export default DriverLayout;